/* Quote page (SA Request a Quote app): lay the app's quote out like the cart drawer.

   Loaded only on /pages/request-for-quote (sections/main-page.liquid), which also
   renders the "Your quote" bar and its Submit quote button. The app renders and
   re-renders its own markup, so every change here is applied again after each
   render and never replaces an element the app listens to:
   - product rows get the cart drawer's quantity stepper (- and + around the app's
     own input) and trash button, and links to the product on this site;
   - the bar's button presses the app's own submit button, and mirrors its state;
   - after sending, "Continue shopping" stays on this site (the app's button goes to
     the primary domain);
   - what the customer types, and the sections they closed, are put back after the
     app rebuilds its form (it does so, empty and all open, whenever a quantity
     changes); closing a section animates like the theme's disclosures.
   Layout and looks are in assets/quote-page.css. */
(function () {
  var TRASH = '<svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5zm2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5z" fill="currentColor"/></svg>';
  var bar = document.querySelector('[data-quote-submit]');

  function fire(el, type) {
    el.dispatchEvent(new Event(type, { bubbles: true }));
  }

  // Links the app writes with the store's own domain go to the same page on this site.
  function localLink(a) {
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    try {
      var u = new URL(href, location.href);
      if (u.host !== location.host && /\/(products|collections)\//.test(u.pathname)) {
        a.setAttribute('href', u.pathname + u.search + u.hash);
      }
    } catch (e) {}
  }

  function stepper(input) {
    if (input.closest('.qty-input')) return;
    var wrap = document.createElement('div');
    wrap.className = 'qty-input qty-input--combined inline-flex items-center';
    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'qty-input__btn btn btn--minus';
    minus.innerHTML = '<span class="visually-hidden">Decrease quantity</span>';
    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'qty-input__btn btn btn--plus';
    plus.innerHTML = '<span class="visually-hidden">Increase quantity</span>';
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(minus);
    wrap.appendChild(input);
    wrap.appendChild(plus);
    input.classList.add('qty-input__input', 'input');
    function step(d) {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + d);
      if (String(v) === input.value) return;
      input.value = v;
      fire(input, 'input');
      fire(input, 'change');
      fire(input, 'blur');
    }
    minus.addEventListener('click', function () { step(-1); });
    plus.addEventListener('click', function () { step(1); });
  }

  function trash(btn) {
    if (btn.classList.contains('cart-item__remove')) return;
    btn.classList.add('cart-item__remove', 'btn', 'btn--icon', 'text-current', 'tap-target');
    btn.setAttribute('aria-label', 'Remove');
    btn.innerHTML = TRASH;
  }

  // The app rebuilds its whole form, empty, whenever a quantity changes, which would
  // throw away what the customer typed. Remember the fields and put them back.
  var typed = {};
  var SKIP = /^(text__1791307860172|grfqNameGroups)/;
  function fieldOf(el) {
    return el && el.name && !SKIP.test(el.name) && el.closest('#grfq-page form') &&
      /^(INPUT|SELECT|TEXTAREA)$/.test(el.tagName) && el.type !== 'hidden' ? el : null;
  }
  function remember(e) {
    var el = fieldOf(e.target);
    if (el) typed[el.name] = el.value;
  }
  document.addEventListener('input', remember, true);
  document.addEventListener('change', remember, true);
  function restore() {
    document.querySelectorAll('#grfq-page form [name]').forEach(function (el) {
      if (!fieldOf(el) || !(el.name in typed) || el.value === typed[el.name]) return;
      if (el.value !== '' && el.tagName !== 'SELECT') return;  // never overwrite what is there
      if (document.activeElement === el) return;
      el.value = typed[el.name];
    });
  }

  // Sections open and close like the theme's disclosures (assets/main.js
  // DetailsDisclosure): the height slides over 0.3s. The app's own toggle hides the
  // fields at once and only animates the spacing, so this script handles the click
  // itself. The app also rebuilds every section open after a quantity change, so the
  // ones the customer closed are closed again after each rebuild.
  var closed = {};
  function setState(row, open) {
    var btn = row.querySelector('.grfq-collapsible-button');
    var panel = row.querySelector('.grfq__collapsible');
    panel.classList.toggle('--show', open);
    panel.classList.toggle('--hide', !open);
    panel.style.maxHeight = open ? 'none' : '0px';
    btn.classList.toggle('--active', open);
    btn.classList.toggle('--disActive', !open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function slide(row, open) {
    var panel = row.querySelector('.grfq__collapsible');
    var done = function (e) {
      if (e && e.target !== panel) return;
      panel.removeEventListener('transitionend', done);
      clearTimeout(timer);
      panel.classList.remove('quote-sliding');
      panel.style.height = '';
      panel.classList.remove('quote-flat');
      if (!open) setState(row, false);
    };
    var timer = setTimeout(done, 450);
    panel.addEventListener('transitionend', done);
    if (open) {
      setState(row, true);
      var full = panel.scrollHeight;
      panel.style.height = '0px';
      panel.classList.add('quote-flat');
      void panel.offsetHeight;
      panel.classList.add('quote-sliding');
      panel.style.height = full + 'px';
      panel.classList.remove('quote-flat');
    } else {
      var btn = row.querySelector('.grfq-collapsible-button');
      btn.classList.remove('--active');
      btn.classList.add('--disActive');
      btn.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = 'none';
      panel.style.height = panel.offsetHeight + 'px';
      panel.classList.add('quote-sliding');
      void panel.offsetHeight;
      panel.style.height = '0px';
      panel.classList.add('quote-flat');
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#grfq-page .grfq-collapsible-button');
    if (!btn) return;
    var row = btn.closest('.grfq-form-row');
    if (!row || !row.querySelector('.grfq__collapsible')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var open = row.querySelector('.grfq__collapsible').classList.contains('--hide');
    if (row.id) closed[row.id] = !open;
    slide(row, open);
  }, true);
  function keepClosed() {
    Object.keys(closed).forEach(function (id) {
      var row = document.getElementById(id);
      var panel = row && row.querySelector('.grfq__collapsible');
      if (!panel || panel.classList.contains('quote-sliding')) return;
      var isOpen = !panel.classList.contains('--hide');
      if (closed[id] && isOpen) setState(row, false);
    });
  }

  // After a quote is sent the app shows "Thank you" with its own Continue Shopping
  // button, which goes to the store's primary domain (emiliomiti.com) whatever site
  // the customer is on. It is hidden; the same two theme buttons as the empty quote
  // (layout/theme.liquid) go to this site's home page and to Financing.
  function thankYou() {
    var box = document.querySelector('#grfq-page .grfq__popupForm__thankyouButtons');
    if (!box || box.querySelector('.sa-continue-row')) return;
    var row = document.createElement('div');
    row.className = 'sa-continue-row';
    row.innerHTML = '<a class="btn btn--primary" href="/">Continue shopping</a><a class="btn btn--secondary" href="/pages/financing">Financing</a>';
    box.appendChild(row);
  }

  function decorate() {
    restore();
    keepClosed();
    thankYou();
    document.querySelectorAll('#grfq-page .grfq-v2-product-row').forEach(function (row) {
      row.querySelectorAll('a[href]').forEach(localLink);
      var qty = row.querySelector('.grfq-v2-product-row__quantity input');
      if (qty) stepper(qty);
      var del = row.querySelector('.grfq-v2-delete-button');
      if (del) trash(del);
    });
    if (!bar) return;
    var appBtn = document.querySelector('#grfq-page .grfq__popupForm__buttonPrimary');
    var hasItems = !!document.querySelector('#grfq-page .grfq-v2-product-row');
    document.documentElement.classList.toggle('quote-page--empty', !appBtn || !hasItems);
    bar.disabled = !appBtn || !hasItems || appBtn.disabled;
    bar.classList.toggle('is-loading', !!(appBtn && /loading|submitting/i.test(appBtn.className + ' ' + (appBtn.getAttribute('aria-busy') || ''))));
  }

  // The bar sticks right under the site header, which shrinks (or hides) on scroll,
  // so follow its visible bottom edge rather than the theme's full --header-height.
  var head = document.querySelector('store-header, .header');
  var stuck = document.querySelector('.quote-page__bar');
  function place() {
    if (!head || !stuck) return;
    var b = Math.max(0, Math.round(head.getBoundingClientRect().bottom));
    stuck.style.top = b + 'px';
    // fields scrolled into view (tabbing, error jumps) stop below the header and bar
    document.documentElement.style.scrollPaddingTop = (b + stuck.offsetHeight + 16) + 'px';
  }
  var placing = false;
  function schedulePlace() {
    if (placing) return;
    placing = true;
    requestAnimationFrame(function () { placing = false; place(); });
  }
  window.addEventListener('scroll', schedulePlace, { passive: true });
  window.addEventListener('resize', schedulePlace);
  if (head && window.ResizeObserver) new ResizeObserver(schedulePlace).observe(head);
  place();

  if (bar) {
    bar.addEventListener('click', function () {
      var appBtn = document.querySelector('#grfq-page .grfq__popupForm__buttonPrimary');
      if (appBtn && !appBtn.disabled) appBtn.click();
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; decorate(); });
  }
  // React to the app's renders, not to this script's own class and state changes.
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var t = list[i].target;
      if (list[i].type === 'childList' || (t !== document.documentElement && t !== bar)) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class', 'href'] });
  schedule();
})();
